export const getMainStyle = {
  backgroundColor: "background.default",
  color: "text.primary",
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  width: "100vw",
  overflowY: "auto",
  boxSizing: "border-box",
  paddingLeft: "60px",

  "@media only screen and (max-width: 960px)": {
    paddingLeft: 0,
  },
};

export const getTooltipGraph = {
  backgroundColor: "tooltip.background",
  color: "text.contrastPrimary",
  borderRadius: "6px",
  fontSize: "0.8125rem",
};

export const getTooltipGraphLabel = {
  mb: 0.375,
  justifyContent: "center",
  display: "flex",
  fontSize: "0.8125rem",
  color: "text.contrastPrimary",
};

export const getTooltipGraphPayload = {
  display: "flex",
  justifyContent: "left",
  margin: 0,
  padding: "0px 5px 5px 5px",
  fontSize: "0.8125rem",
  color: "text.contrastPrimary",
};
